import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronSortVertical = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.61672 2.88456C8.25583 2.59406 7.7444 2.59406 7.3835 2.88456C6.40825 3.66958 5.53835 4.58434 4.79648 5.60489C4.70528 5.72871 4.65624 5.88451 4.66865 6.04988C4.69618 6.41704 5.01615 6.69236 5.38331 6.66482C7.1254 6.53416 8.87483 6.53416 10.6169 6.66482C10.9841 6.69236 11.304 6.41704 11.3316 6.04988C11.344 5.8845 11.2949 5.7287 11.2037 5.60488C10.4619 4.58434 9.59198 3.66958 8.61672 2.88456Z",
		fill: "#71717A"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.38331 9.33522C5.01615 9.30768 4.69618 9.583 4.66865 9.95016C4.65624 10.1155 4.70529 10.2713 4.79649 10.3952C5.53836 11.4157 6.40825 12.3305 7.3835 13.1155C7.7444 13.406 8.25583 13.406 8.61672 13.1155C9.59197 12.3305 10.4619 11.4157 11.2037 10.3952C11.2949 10.2713 11.344 10.1155 11.3316 9.95016C11.304 9.583 10.9841 9.30768 10.6169 9.33522C8.87483 9.46588 7.1254 9.46588 5.38331 9.33522Z",
		fill: "#71717A"
	})]
});
const ForwardRef = forwardRef(SvgChevronSortVertical);
export default ForwardRef;
